import React, { useEffect, useState } from "react";
import { Heart, ListCollapse, ShoppingBag, Star } from "lucide-react";
import "./bestsellingproduct.css";
import { useNavigate } from 'react-router-dom';
import axios from "axios";

const BestSellingProduct = () => {
  const navigate = useNavigate();
  const [favorites, setFavorites] = useState([]);
  // const [cart, setCart] = useState([]);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchrandoProducts = async () => {
    try {
      setLoading(true);
      setError(null);

      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/products/interrando`
      );

      console.log('API Response:', res.data);

      // ✅ FIXED: Extract the data array from the response
      if (res.data.success && Array.isArray(res.data.data)) {
        setProducts(res.data.data);
        console.log('Products set:', res.data.data);
      } else {
        // Fallback if response structure is different
        setProducts(Array.isArray(res.data) ? res.data : []);
      }
    } catch (error) {
      console.error("Error Fetching Products:", error);
      setError(error.message);
      setProducts([]); // Set empty array on error
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchrandoProducts();
    const interval = setInterval(fetchrandoProducts, 900000);
    return () => clearInterval(interval);
  }, []);

  const getImageUrl = (product) => {
    // Handle images array (new format)
    if (product.images && product.images.length > 0) {
      const imagePath = product.images[0].path;

      if (!imagePath) return null;

      if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
        return imagePath;
      }

      const path = imagePath.startsWith('/') ? imagePath.substring(1) : imagePath;
      const baseUrl = process.env.REACT_APP_BASE_URL.split('/api')[0];
      return `${baseUrl}/${path}`;
    }

    // Fallback to imageUrl if it exists
    if (product.imageUrl) {
      const imagePath = product.imageUrl;

      if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
        return imagePath;
      }

      const path = imagePath.startsWith('/') ? imagePath.substring(1) : imagePath;
      const baseUrl = process.env.REACT_APP_BASE_URL.split('/api')[0];
      return `${baseUrl}/${path}`;
    }

    return null;
  };

  const toggleFavorite = (productId) => {
    setFavorites((prev) =>
      prev.includes(productId)
        ? prev.filter((id) => id !== productId)
        : [...prev, productId]
    );
  };

  // const addToCart = (product) => {
  //   setCart((prev) => {
  //     const existingProduct = prev.find((item) => item.id === product.id);
  //     if (existingProduct) {
  //       return prev.map((item) =>
  //         item.id === product.id
  //           ? { ...item, quantity: item.quantity + 1 }
  //           : item
  //       );
  //     }
  //     return [...prev, { ...product, quantity: 1 }];
  //   });
  // };

  const getProductId = (product) => {
    return product._id || product.id;
  };

  // ✅ NEW: Helper function to format price
  const formatPrice = (price) => {
    const numPrice = parseFloat(price) || 0;
    return numPrice.toFixed(2);
  };

  // Loading state
  if (loading && products.length === 0) {
    return (
      <div className="best-selling-container">
        <div className="section-header">
          <h2 className="best-selling-title">Best Selling Products</h2>
          <p className="section-subtitle">Discover our most popular and highly-rated items</p>
        </div>
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading products...</p>
        </div>
      </div>
    );
  }

  // Error state
  if (error && products.length === 0) {
    return (
      <div className="best-selling-container">
        <div className="section-header">
          <h2 className="best-selling-title">Best  Products</h2>
          <p className="section-subtitle">Discover our most popular and highly-rated items</p>
        </div>
        <div className="error-container">
          <p>Error loading products: {error}</p>
          <button onClick={fetchrandoProducts}>Try Again</button>
        </div>
      </div>
    );
  }

  // Empty state
  if (!products || products.length === 0) {
    return (
      <div className="best-selling-container">
        <div className="section-header">
          <h2 className="best-selling-title">Best Selling Products</h2>
          <p className="section-subtitle">Discover our most popular and highly-rated items</p>
        </div>
        <div className="empty-state">
          <ShoppingBag size={48} />
          <p>No products available at the moment</p>
        </div>
      </div>
    );
  }

  return (
    <div className="best-selling-container">
      <div className="section-header">
        <h2 className="best-selling-title">Best Selling Products</h2>
        <p className="section-subtitle">Discover our most popular and highly-rated items</p>
      </div>

      <div className="product-grid">
        {products.map((product) => {
          const productId = getProductId(product);
          return (
            <div key={productId} className="product-card">
              <div className="product-image-container">
                {getImageUrl(product) ? (
                  <img
                    className="product-image"
                    src={getImageUrl(product)}
                    alt={product.name}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "https://via.placeholder.com/200x200?text=No+Image";
                    }}
                  />
                ) : (
                  <div className="placeholder-image">
                    <ShoppingBag className="placeholder-icon" />
                  </div>
                )}
                {/* <button
                  onClick={() => toggleFavorite(productId)}
                  className={`favorite-button ${favorites.includes(productId) ? "favorited" : ""
                    }`}
                  aria-label="Add to Favorites"
                >
                  <Heart
                    size={20}
                    fill={favorites.includes(productId) ? "#ff4757" : "none"}
                    strokeWidth={favorites.includes(productId) ? 0 : 1.5}
                  />
                </button> */}
              </div>

              <div className="product-details">
                <div className="product-header">
                  <h3 className="product-name">{product.name}</h3>
                  <div className="product-rating">
                    <Star size={16} fill="#ffc107" stroke="none" />
                    {product.rating || "4.0"}
                  </div>
                </div>

                <p className="product-description">
                  {product.description?.length > 100
                    ? `${product.description.substring(0, 80)}...`
                    : product.description || 'No description available'}
                </p>

                <div className="product-footer">
                  <span className="product-price">
                    ₹{formatPrice(product.finalPrice || product.price)}
                  </span>
                  <button
                    className="view-details-buttons"
                    onClick={() => {
                      console.log('Navigating to product:', productId);
                      navigate(`/products/${productId}`);
                    }}
                  >
                    {/* <ListCollapse size={18} /> */}
                    View Details
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BestSellingProduct;